<template>
  <!-- Indirizzo di consegna con i suggerimenti del cliente [sc-48860]:
       al focus propone residenza e cantiere, oppure un indirizzo scritto a mano -->
  <div ref="wrapper" class="indirizzo-consegna">
    <input
      :id="id"
      ref="input"
      type="text"
      :value="modelValue"
      :class="{ 'con-freccia': voci.length }"
      placeholder="Via, civico, città…"
      autocomplete="off"
      @focus="aperto = voci.length > 0"
      @input="onInput"
      @blur="onBlur"
      @keydown.esc="aperto = false"
    />
    <!-- freccetta: apre e chiude i suggerimenti, solo se ce ne sono -->
    <button
      v-if="voci.length"
      type="button"
      class="indirizzo-consegna__toggle"
      :title="
        aperto
          ? 'Nascondi indirizzi del cliente'
          : 'Mostra indirizzi del cliente'
      "
      @mousedown.prevent="toggle"
    >
      <i
        class="fa-solid"
        :class="aperto ? 'fa-chevron-up' : 'fa-chevron-down'"
      ></i>
    </button>
    <div v-if="aperto" class="indirizzo-consegna__dropdown">
      <button
        v-for="v in voci"
        :key="v.etichetta"
        type="button"
        class="indirizzo-consegna__option"
        :class="{ selected: v.address === (modelValue || '').trim() }"
        @mousedown.prevent="scegli(v.address)"
      >
        <i
          class="fa-solid"
          :class="v.etichetta === 'Cantiere' ? 'fa-helmet-safety' : 'fa-house'"
        ></i>
        <span>
          <strong>{{ v.etichetta }}:</strong> {{ v.address }}
        </span>
      </button>
      <button
        type="button"
        class="indirizzo-consegna__option indirizzo-consegna__altro"
        @mousedown.prevent="altro"
      >
        <i class="fa-solid fa-pen"></i>
        <span>Altro indirizzo da scrivere manualmente…</span>
      </button>
    </div>
  </div>
</template>

<script>
import { indirizziDiConsegna } from "@/utilities/cliente";

export default {
  name: "IndirizzoConsegna",
  props: {
    modelValue: { type: String, default: "" },
    // cliente scelto nel preventivo, con residenceAddress e worksiteAddress
    cliente: { type: Object, default: null },
    id: { type: String, default: "indirizzo-consegna" },
  },
  // `input` dopo ogni cambio del testo, digitato o scelto: la pagina ricalcola
  // location e link come faceva con l'input semplice
  emits: ["update:modelValue", "input", "blur"],
  data() {
    return { aperto: false };
  },
  computed: {
    voci() {
      return indirizziDiConsegna(this.cliente);
    },
  },
  methods: {
    onInput(e) {
      this.aperto = false;
      this.$emit("update:modelValue", e.target.value);
      this.$emit("input");
    },
    scegli(address) {
      this.aperto = false;
      this.$emit("update:modelValue", address);
      this.$emit("input");
    },
    // Svuota il campo solo se contiene un indirizzo proposto: un testo scritto
    // a mano resta, l'operatore lo sta gia' correggendo
    altro() {
      this.aperto = false;
      const attuale = (this.modelValue || "").trim();
      if (this.voci.some((v) => v.address === attuale)) {
        this.$emit("update:modelValue", "");
        this.$emit("input");
      }
      this.$refs.input?.focus();
    },
    toggle() {
      this.aperto = !this.aperto;
      this.$refs.input?.focus();
    },
    onBlur() {
      this.aperto = false;
      this.$emit("blur");
    },
    focus() {
      this.$refs.input?.focus();
    },
  },
};
</script>

<style scoped>
/* Largo come gli altri campi del preventivo (Cliente, Data): 350px come
   .field input, l'input riempie il contenitore */
.indirizzo-consegna {
  position: relative;
  width: 350px;
  max-width: 100%;
}

.indirizzo-consegna input {
  width: 100%;
}

/* con la freccetta il testo non deve finirci sotto */
.indirizzo-consegna input.con-freccia {
  padding-right: 26px;
}

.indirizzo-consegna__toggle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #888;
  font-size: 10px;
  padding: 0;
}

.indirizzo-consegna__toggle:hover {
  color: #374151;
}

/* Stessa resa della tendina di StatusSelect */
.indirizzo-consegna__dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 200;
  padding: 4px;
}

.indirizzo-consegna__option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
}

.indirizzo-consegna__option:hover,
.indirizzo-consegna__option.selected {
  background: #f5f5f5;
}

.indirizzo-consegna__option i {
  font-size: 13px;
  color: #374151;
  width: 14px;
}

.indirizzo-consegna__altro {
  color: #6b7280;
  border-top: 1px solid #f0f0f0;
  border-radius: 0 0 6px 6px;
}
</style>
